import React from "react";
import { css } from "styled-components/macro";
import { NavLink, Route } from "react-router-dom";
import HistoryNavigator from "./navigator";
import HistoryList from "./../UI/history/listUI";
import HistoryPage from "./list";
const config = [
  {
    title: "تایید شده",
    path: "/",
    color: "#afefae",
    status: 1
  },
  {
    title: "کنسل شده",
    path: "/canceled",
    color: "#f7baba",
    status: 2
  },
  {
    title: "پیگیری",
    path: "/followup",
    color: "#ffe65e",
    status: 5
  },
  {
    title: "عدم پاسخ",
    path: "/rejected",
    color: "#efceae",
    status: 4
  },
  {
    title: "نمونه کاری",
    path: "/portfolio",
    color: "#efc5ae",
    status: 3
  }
];

export default function History(props) {
  const { path } = props.match;
  return (
    <>
      <HistoryNavigator perfix={path} config={config}></HistoryNavigator>
      {config.map(route => (
        <Route
          path={path + route.path}
          exact
          component={p => (
            <HistoryPage
              {...props}
              status={route.status}
              color={route.color}
            ></HistoryPage>
          )}
        ></Route>
      ))}
    </>
  );
}
